import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the full plugin icon
 * 
 * @param {Object} props - The props of the component
 * @returns The full plugin icon
 */
const FullPluginIcon = (props) => (
  <Icon viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="6" y="6" width="28" height="28" rx="2" stroke="currentColor" strokeWidth="2" />
  </Icon>
);

export default React.memo(FullPluginIcon);
